




















import Popper, { ModifierFn } from 'popper.js';
import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      isOpen: false,
      popper: null as Popper | null,
      portalOpen: false,
      popoverStyle: {},
    };
  },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitClick() {
      this.$emit('click');
    },
    togglePopover() {
      if (this.portalOpen && this.popper) {
        this.popper.destroy();
      }

      this.portalOpen = !this.portalOpen;

      this.$nextTick(() => {
        this.isOpen = !this.isOpen;

        if (this.portalOpen) {
          const popover = this.$refs.popover as Element;
          const dropdown = this.$refs.dropdown as Element;

          this.popper = new Popper(dropdown, popover, {
            placement: 'bottom-start',
            modifiers: {
              applyStyle: {
                enabled: false,
              },
              applyVueStyle: {
                enabled: true,
                fn: this.applyStyle as ModifierFn,
                order: 900,
              },
            },
          });
        }
      });
    },
    applyStyle(data, options) {
      this.popoverStyle = data.styles;
      return {};
    },
  },
});
